<template>
  <el-table
      :data="tableData"
      style="width: 100%"
      show-summary
      :summary-method="getCommonReportSummaries"
  >
    <el-table-column prop="type" label="Тип" min-width="180"/>
    <el-table-column label="Кол-во для тарификации" min-width="190">
      <template #default="scope">
        <span v-html="commonReportAmountFormatter(scope.row)"></span>
      </template>
    </el-table-column>
    <el-table-column label="Цена / ед." min-width="180">
      <template #default="scope">
        <span v-html="commonReportUnitPriceFormatter(scope.row)"></span>
      </template>
    </el-table-column>
    <el-table-column :formatter="row => formatNumber(row.total)" label="Всего" min-width="180"/>
  </el-table>
</template>

<script>
export default {
  name: 'GeneralReportTable',
  props: ["tableData"],
  methods: {
    commonReportAmountFormatter(row) {
      if (row.justAmount) return ""
      if (row._type !== 2) return row.sent
      return row.records.map(r => `${r.rateName}`).join("<br/>")
    },
    commonReportUnitPriceFormatter(row) {
      if (row.justAmount || row.noAverage) return ""
      if (row._type !== 2) return parseFloat((row.total / Math.max(row.sent, 1))).toFixed(4)
      return row.records.map(r => `${r.amount} x ${r.unitPrice}`).join("<br/>")
    },
    getCommonReportSummaries() {
      return ["Итого", "", "", this.tableData.reduce((acc, r) => acc + (Number(r.total) || 0), 0).toFixed(2)]
    }
  }
}
</script>